import { useSyncExternalStore } from 'react';

import { getAppUpdateState, subscribeToAppUpdate } from './appUpdateCheck';
import { isOlderThan } from './compareVersions';
import { UpdateAvailableModal } from './UpdateAvailableModal';
import { UpdateRequiredScreen } from './UpdateRequiredScreen';

/**
 * Blocks a native build below the minimum version and offers an update to one below the latest.
 * Renders nothing on the web, and nothing while the policy is unknown: a failed check never
 * blocks. `installAppUpdateCheck` keeps the policy current.
 */
export function UpdateGate() {
	const { appInfo, policy, upgradeRequired } = useSyncExternalStore(subscribeToAppUpdate, getAppUpdateState);

	if (!appInfo) {
		return null;
	}

	if (upgradeRequired || isOlderThan(appInfo.version, policy?.minimumVersion)) {
		return <UpdateRequiredScreen storeUrl={policy?.storeUrl ?? null} />;
	}

	if (policy?.latestVersion && policy.storeUrl && isOlderThan(appInfo.version, policy.latestVersion)) {
		return (
			<UpdateAvailableModal
				key={policy.latestVersion}
				latestVersion={policy.latestVersion}
				storeUrl={policy.storeUrl}
			/>
		);
	}

	return null;
}
